<template>
  <div class="rn-contact-address-area rn-section-gap bg-modern-layout">
    <v-container>
      <v-row class="row-gap-30 justify-center">
        <!-- Start Single Address (Phone) -->
        <v-col lg="6" md="6" sm="6" cols="12" class="d-flex" v-if="NOTARIA.Contacto.Telefono || NOTARIA.Contacto.Fax || NOTARIA.Contacto.Movil">
          <div class="modern-contact-card d-flex align-start w-100" :class="{ 'no-icon': !showIcons }">
            <div class="card-glow-aura" :style="{ background: 'radial-gradient(circle at top right, ' + (estiloTarjetaTituloColor || '#1a237e') + '10, transparent 60%)' }"></div>
            
            <div v-if="showIcons" class="modern-icon-container d-flex align-center justify-center mr-5">
              <v-icon class="modern-contact-icon" large>{{ 'mdi-phone-outline' }}</v-icon>
            </div>
            
            <div class="card-content-wrapper flex-grow-1">
              <h3 class="modern-contact-title mb-2">{{ $t('telefono') }}</h3>
              <div class="modern-contact-details">
                <p v-if="NOTARIA.Contacto.Telefono || NOTARIA.Contacto.Movil" class="mb-1">
                  <a v-if="NOTARIA.Contacto.Telefono" aria-label="teléfono de la notaría" :href="'tel:'+NOTARIA.Contacto.Telefono" class="detail-link">{{ NOTARIA.Contacto.Telefono }}</a>
                  <span v-if="NOTARIA.Contacto.Telefono && NOTARIA.Contacto.Movil" class="mx-2 separator">|</span>
                  <a v-if="NOTARIA.Contacto.Movil" :href="'tel:'+NOTARIA.Contacto.Movil" class="detail-link">{{ NOTARIA.Contacto.Movil }}</a>
                </p>
                <p v-if="NOTARIA.Contacto.Fax" class="mb-0">
                  <a :href="'tel:'+NOTARIA.Contacto.Fax" class="detail-link font-italic">{{ NOTARIA.Contacto.Fax }} (Fax)</a>
                </p>
              </div>
            </div>
          </div>
        </v-col>
        <!-- End Single Address -->

        <!-- Start Single Address (Email) -->
        <v-col lg="6" md="6" sm="6" cols="12" class="d-flex" v-if="NOTARIA.Contacto.Email">
          <div class="modern-contact-card d-flex align-start w-100" :class="{ 'no-icon': !showIcons }">
            <div class="card-glow-aura" :style="{ background: 'radial-gradient(circle at top right, ' + (estiloTarjetaTituloColor || '#1a237e') + '10, transparent 60%)' }"></div>
            
            <div v-if="showIcons" class="modern-icon-container d-flex align-center justify-center mr-5">
              <v-icon class="modern-contact-icon" large>{{ 'mdi-email-outline' }}</v-icon>
            </div>
            
            <div class="card-content-wrapper flex-grow-1">
              <h3 class="modern-contact-title mb-2">{{ $t('email') }}</h3>
              <div class="modern-contact-details">
                <p v-if="NOTARIA.Contacto.Email" class="mb-1">
                  <a :href="'mailto:'+NOTARIA.Contacto.Email" class="detail-link">{{ NOTARIA.Contacto.Email }}</a>
                </p>
                <p v-if="NOTARIA.Contacto.Email2" class="mb-0">
                  <a :href="'mailto:'+NOTARIA.Contacto.Email2" class="detail-link">{{ NOTARIA.Contacto.Email2 }}</a>
                </p>
              </div>
            </div>
          </div>
        </v-col>
        <!-- End Single Address -->

        <!-- Start Single Address (Location) -->
        <v-col lg="6" md="6" sm="6" cols="12" class="d-flex">
          <div class="modern-contact-card d-flex align-start w-100" :class="{ 'no-icon': !showIcons }">
            <div class="card-glow-aura" :style="{ background: 'radial-gradient(circle at top right, ' + (estiloTarjetaTituloColor || '#1a237e') + '10, transparent 60%)' }"></div>
            
            <div v-if="showIcons" class="modern-icon-container d-flex align-center justify-center mr-5">
              <v-icon class="modern-contact-icon" large>{{ 'mdi-map-marker-outline' }}</v-icon>
            </div>
            
            <div class="card-content-wrapper flex-grow-1">
              <h3 class="modern-contact-title mb-2">{{ $t('localizacion') }}</h3>
              <div class="modern-contact-details">
                <p class="mb-0">
                  <a :href="NOTARIA.Contacto.EnlaceMaps" target="_blank" class="detail-link address-link">
                    {{ NOTARIA.Contacto.Direccion }}<br>
                    <span class="location-sub">{{ NOTARIA.Contacto.CP }}, {{ NOTARIA.Contacto.Municipio }}, {{ NOTARIA.Contacto.Provincia }}</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </v-col>
        <!-- End Single Address -->

        <!-- Start Single Address (Access) -->
        <v-col lg="6" md="6" sm="6" cols="12" class="d-flex" v-if="NOTARIA.Contacto.Parking">
          <div class="modern-contact-card d-flex align-start w-100" :class="{ 'no-icon': !showIcons }">
            <div class="card-glow-aura" :style="{ background: 'radial-gradient(circle at top right, ' + (estiloTarjetaTituloColor || '#1a237e') + '10, transparent 60%)' }"></div>
            
            <div v-if="showIcons" class="modern-icon-container d-flex align-center justify-center mr-5">
              <v-icon class="modern-contact-icon" large>{{ 'mdi-bus-school' }}</v-icon>
            </div>
            
            <div class="card-content-wrapper flex-grow-1">
              <h3 class="modern-contact-title mb-2">{{ $t('accesos') }}</h3>
              <div class="modern-contact-details">
                <p v-html="NOTARIA.Contacto.Parking.replace(/(?:\r\n|\r|\n)/g, '<br>')" class="mb-0 access-text"></p>
              </div>
            </div>
          </div>
        </v-col>
        <!-- End Single Address -->

        <!-- Start Single Address (Parking) -->
        <v-col lg="6" md="6" sm="6" cols="12" class="d-flex" v-if="NOTARIA.Contacto.Accesos">
          <div class="modern-contact-card d-flex align-start w-100" :class="{ 'no-icon': !showIcons }">
            <div class="card-glow-aura" :style="{ background: 'radial-gradient(circle at top right, ' + (estiloTarjetaTituloColor || '#1a237e') + '10, transparent 60%)' }"></div>
            
            <div v-if="showIcons" class="modern-icon-container d-flex align-center justify-center mr-5">
              <v-icon class="modern-contact-icon" large>{{ 'mdi-car' }}</v-icon>
            </div>
            
            <div class="card-content-wrapper flex-grow-1">
              <h3 class="modern-contact-title mb-2">Parking</h3>
              <div class="modern-contact-details">
                <p v-html="NOTARIA.Contacto.Accesos.replace(/(?:\r\n|\r|\n)/g, '<br>')" class="mb-0 access-text"></p>
              </div>
            </div>
          </div>
        </v-col>
        <!-- End Single Address -->
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from '../../store/index'
const store = useStore()
const { NOTARIA } = storeToRefs(store)

import { useUtils } from '#imports';
const { $t } = useUtils()

import { useStyles } from '../../store/styles';
const style = useStyles();

const showIcons = computed(() => {
  return NOTARIA.value?.Theme?.Contacto?.ShowIcons !== false;
})

const estiloTarjetaTituloColor = computed(() => style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Color || '#1a237e')
const estiloTarjetaTituloShadow = computed(() => {
  const bg = style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.BackgroundColor;
  return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTarjetaTituloFont = computed(() => style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Font || 'inherit')
const estiloTarjetaTituloSize = computed(() => style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Size || '1.35rem')
const estiloTarjetaTituloWeight = computed(() => style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Weight || '700')
const estiloTarjetaTituloAlign = computed(() => style.ThemeSectionContacto?.Tarjeta?.Titulo?.css?.Align || 'left')

const estiloTarjetaDescripcionColor = computed(() => style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Color || '#4a5568')
const estiloTarjetaDescripcionShadow = computed(() => {
  const bg = style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.BackgroundColor;
  return (bg && bg !== 'transparent' && bg !== '#00000000' && bg !== '#0000') ? "4px 2px 6px " + bg : "none";
})
const estiloTarjetaDescripcionFont = computed(() => style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Font || 'inherit')
const estiloTarjetaDescripcionWeight = computed(() => style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Weight || '400')
const estiloTarjetaDescripcionSize = computed(() => style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Size || '1.05rem')
const estiloTarjetaDescripcionAlign = computed(() => style.ThemeSectionContacto?.Tarjeta?.Descripcion?.css?.Align || 'left')

// Pre-computed translucent colors for styles to avoid compile-time Sass rgba() issues
const estiloIconBgColor = computed(() => {
  const color = estiloTarjetaTituloColor.value;
  if (color && color.startsWith('#')) {
    return color + '0d'; // ~5% opacity
  }
  return 'rgba(26, 35, 126, 0.05)';
})

const estiloCardBorderHoverColor = computed(() => {
  const color = estiloTarjetaTituloColor.value;
  if (color && color.startsWith('#')) {
    return color + '26'; // ~15% opacity
  }
  return 'rgba(26, 35, 126, 0.15)';
})

const estiloIconShadowHoverColor = computed(() => {
  const color = estiloTarjetaTituloColor.value;
  if (color && color.startsWith('#')) {
    return color + '66'; // ~40% opacity
  }
  return 'rgba(26, 35, 126, 0.4)';
})
</script>

<style lang="scss" scoped>
.bg-modern-layout {
  background-color: #f8fafc !important;
  padding-top: 80px;
  padding-bottom: 80px;
}

.row-gap-30 {
  row-gap: 30px;
}

/* Premium Card Styles */
.modern-contact-card {
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  padding: 35px 30px;
  box-shadow: 0 10px 30px -15px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  
  &.no-icon {
    padding: 35px 35px;
  }
}

.card-glow-aura {
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  pointer-events: none;
  opacity: 0.5;
  transition: opacity 0.4s ease, transform 0.4s ease;
}

/* Icon Styles */
.modern-icon-container {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: v-bind(estiloIconBgColor);
  color: v-bind(estiloTarjetaTituloColor) !important;
  flex-shrink: 0;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  
  .modern-contact-icon {
    font-size: 24px !important;
    color: inherit !important;
    transition: transform 0.4s ease;
  }
}

/* Hover States */
.modern-contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px -20px rgba(0, 0, 0, 0.12);
  border-color: v-bind(estiloCardBorderHoverColor);
  
  .card-glow-aura {
    opacity: 1;
    transform: scale(1.1);
  }
  
  .modern-icon-container {
    background: v-bind(estiloTarjetaTituloColor);
    color: #ffffff !important;
    box-shadow: 0 8px 20px -6px v-bind(estiloIconShadowHoverColor);
    
    .modern-contact-icon {
      transform: scale(1.1);
    }
  }
}

/* Typography and Content alignment */
.modern-contact-title {
  color: v-bind(estiloTarjetaTituloColor) !important;
  text-shadow: v-bind(estiloTarjetaTituloShadow) !important;
  font-family: v-bind(estiloTarjetaTituloFont) !important;
  font-size: v-bind(estiloTarjetaTituloSize) !important;
  font-weight: v-bind(estiloTarjetaTituloWeight) !important;
  text-align: v-bind(estiloTarjetaTituloAlign) !important;
}

.modern-contact-details, .access-text {
  color: v-bind(estiloTarjetaDescripcionColor) !important;
  text-shadow: v-bind(estiloTarjetaDescripcionShadow) !important;
  font-family: v-bind(estiloTarjetaDescripcionFont) !important;
  font-size: v-bind(estiloTarjetaDescripcionSize) !important;
  font-weight: v-bind(estiloTarjetaDescripcionWeight) !important;
  text-align: v-bind(estiloTarjetaDescripcionAlign) !important;
}

.detail-link {
  color: inherit !important;
  text-decoration: none !important;
  position: relative;
  display: inline-block;
  transition: color 0.3s ease;
  
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1.5px;
    bottom: -2px;
    left: 0;
    background-color: v-bind(estiloTarjetaTituloColor);
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
  }
  
  &:hover {
    color: v-bind(estiloTarjetaTituloColor) !important;
    
    &::after {
      transform: scaleX(1);
      transform-origin: bottom left;
    }
  }
}

.address-link {
  line-height: 1.5;
}

.location-sub {
  font-size: 0.95em;
  opacity: 0.85;
}

.separator {
  opacity: 0.3;
}

.access-text {
  line-height: 1.6;
}
</style>
